import type { CategoryTypes } from '~/modules/category/type';

export const getSlideSize = (type?: CategoryTypes) => {
    switch (type) {
        case 'products':
            return 158;
        case 'projects':
            return 300;
        case 'professionals':
            return 240;
        default:
            return 414;
    }
};
